export default [
  {
    path: 'relatorios/premio-pago-baixo',
    name: 'premio-pago-baixo',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Prêmio Pago Baixo',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Relatórios', link: 'relatorios' },
        { name: 'Prêmio Pago Baixo' }
      ]
    }
  },
]